import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Logo from "../assets/images/logo.svg";
import siteMetaData from "../constants/siteMetaData.js";

function SEO({description, lang, meta, image, title, imageFormat}) {
  const {site} = siteMetaData[0];

  const metaDescription = description || site.siteMetadata.description;

  const metaUrl = site.siteMetadata.siteUrl;

  const metaImage =
    typeof image === "undefined" ? `${metaUrl}${Logo}` : `${"https://"}${image}`;

  const imageType = imageFormat === "jpg" ? "image/jpeg" : "image/png";

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          property: `og:image:type`,
          content: imageType,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: metaUrl,
        },
        {
          property: `og:site_name`,
          content: site.siteMetadata.siteName,
        },
        {
          property: `og:image:secure_url`,
          content: metaImage,
        },
        {
          property: `twitter:image:alt`,
          content: metaImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:image`,
          content: metaImage,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
